import React, { useCallback, useEffect, useState } from "react";
import { Container } from "./style";
import { useApi } from "../../../hooks/api";
import { ModalHeader } from "../../ModalHeader";
import { useGlobal } from "../../../hooks/global";
import { ModalGeneric } from "../../ModalGeneric";
import { ContentOrLoading } from "../../Loadings/ContentOrLoading";
import { FormPlan } from "./form";
import { permissionsBusinessOptions, planIconsOptions } from "../../../utils/options";

interface IModalReservationsProps {
  onCancel: Function;
  onSave: Function;
  defaultId?: string;
  openModal: boolean;
  backgroundVisible?: boolean;
}

const texts: any = {
  title: {
    new: "Cadastro de Plano",
    edit: "Informações do Plano",
  },
  subTitle: {
    new: "Informe os dados do plano",
    edit: "Segue abaixo as informações da plano",
  },
};

export const ModalPlans: React.FC<IModalReservationsProps> = (props) => {
  const { onCancel, onSave, openModal, backgroundVisible, defaultId } = props;

  const { api } = useApi();
  const { theme, notify } = useGlobal();

  const [loading, setLoading] = useState(!!defaultId);
  const [defaultData, setDefaultData] = useState<any>({});

  const searchPlan = useCallback(async () => {
    if (defaultId) {
      setLoading(true);
      try {
        const { data } = await api.get(`/plan/${defaultId}`)

        const _data = {} as any;
        
        const permissionOptions = permissionsBusinessOptions.filter(option => data?.permissions.includes(option.value));
        const iconOptions = planIconsOptions.find(option => data?.icon.includes(option.value));

        Object.assign(_data, {
          ...data,
          permissions: permissionOptions,
          icon: iconOptions,
        });
        
        setDefaultData({ ..._data });
      } catch (err) {
        console.error(err);
        notify("Erro ao buscar a empresa", "error");
        onCancel();
      } finally {
        setLoading(false);
      }
    }
  }, [defaultId]);

  useEffect(() => {
    searchPlan();
  }, []);

  return (
    <ModalGeneric
      backgroundVisible={backgroundVisible}
      open={openModal}
      onClose={() => { }}
    >
      <Container theme={theme}>
        <ModalHeader
          title={texts.title[defaultId ? "edit" : "new"]}
          subTitle={texts.subTitle[defaultId ? "edit" : "new"]}
          onCancel={() => onCancel()}
          theme={theme}
        />
        <div style={{ marginBottom: 20 }} />
        <ContentOrLoading type="wave" loading={loading} theme={theme}>
          {!loading && (
            <FormPlan
              onSave={onSave}
              onCancel={onCancel}
              defaultData={defaultData}
            />
          )}
        </ContentOrLoading>
      </Container>
    </ModalGeneric>
  );
};
